import React from "react";

import "./deleteButton.css";
import TrashBinIcon from "../assets/icons/trashBinIcon";

interface DeleteButtonProps {
    onDelete: () => void;
    disabled?: boolean;
}

export default function DeleteButton(props: DeleteButtonProps) {

    return <div onClick={() => {
        if(!props.disabled) {
            props.onDelete();
        }
    }} className={"delete-button" + (props.disabled ? " disabled" : "")}>
        <TrashBinIcon/>
    </div>
}